import { PropAsset } from './PropAsset';

// House - Ev / Kulübe
// TODO: Replace with SVG asset
export class House extends PropAsset {
  readonly id = 'house';
  readonly width = 100;
  readonly height = 110;
  readonly walkable = false;
  readonly collisionRadius = 1.5;
  readonly occludesPlayer = true;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 22 * s, 11 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Wall colors based on variant
    const wallColors = ['#a08570', '#8b7355', '#7a8a7a']; // Light wood, dark wood, stone
    const roofColors = ['#5a3a2a', '#4a2a1a', '#3a3a3a'];

    // Walls - Duvarlar
    ctx.fillStyle = wallColors[variant || 0] || wallColors[0];
    ctx.fillRect(cx - 20 * s, cy - 38 * s, 40 * s, 38 * s);

    // Side wall shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.fillRect(cx + 10 * s, cy - 38 * s, 10 * s, 38 * s);

    // Roof - Çatı
    ctx.fillStyle = roofColors[variant || 0] || roofColors[0];
    ctx.beginPath();
    ctx.moveTo(cx, cy - 58 * s);  // Peak
    ctx.lineTo(cx - 25 * s, cy - 38 * s);  // Left
    ctx.lineTo(cx + 25 * s, cy - 38 * s);  // Right
    ctx.closePath();
    ctx.fill();

    // Roof highlight
    ctx.fillStyle = 'rgba(255,255,255,0.1)';
    ctx.beginPath();
    ctx.moveTo(cx, cy - 58 * s);
    ctx.lineTo(cx - 25 * s, cy - 38 * s);
    ctx.lineTo(cx, cy - 38 * s);
    ctx.closePath();
    ctx.fill();

    // Door - Kapı
    ctx.fillStyle = '#4a3020';
    ctx.fillRect(cx - 6 * s, cy - 22 * s, 12 * s, 22 * s);

    // Door handle
    ctx.fillStyle = '#8a7a60';
    ctx.beginPath();
    ctx.arc(cx + 3 * s, cy - 10 * s, 1.5 * s, 0, Math.PI * 2);
    ctx.fill();

    // Windows - Pencereler
    ctx.fillStyle = '#87ceeb';
    ctx.fillRect(cx - 16 * s, cy - 32 * s, 8 * s, 8 * s);
    ctx.fillRect(cx + 8 * s, cy - 32 * s, 8 * s, 8 * s);

    // Window frames
    ctx.strokeStyle = '#4a3020';
    ctx.lineWidth = 1 * s;
    ctx.strokeRect(cx - 16 * s, cy - 32 * s, 8 * s, 8 * s);
    ctx.strokeRect(cx + 8 * s, cy - 32 * s, 8 * s, 8 * s);

    // Chimney (variant 0 only)
    if (variant === 0) {
      ctx.fillStyle = '#5a4a4a';
      ctx.fillRect(cx + 8 * s, cy - 55 * s, 6 * s, 12 * s);
    }
  }
}
